<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="generalLang">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>
<input type="hidden" name="cid" value="">
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.reportNo }}</label>
          </div>
          <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="report_no"
            [ngClass]="formErrorClass(createForm.controls.report_no, createFormSubmitted)">
          <!-- <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.report_no, value:createForm.controls.report_no, submitted:createFormSubmitted }">
          </ng-template> -->

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.type }}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="type"
            [ngClass]="formErrorClass(createForm.controls.type, createFormSubmitted)">
            <option value="">Select Type</option>
            <option *ngFor="let type of typeConfig" [ngValue]="type.value">{{type.text}}</option>
          </select>

          <!-- <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.type, value:createForm.controls.type, submitted:createFormSubmitted }">
          </ng-template> -->

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.date }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="plaining_date"
            [ngClass]="formErrorClass(createForm.controls.plaining_date, createFormSubmitted)">

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.performedBy }}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="employee_ids"
            [ngClass]="formErrorClass (createForm.controls.employee_ids, createFormSubmitted)">
            <option value="">{{ generalLang.selectType }}</option>
            <option *ngFor="let resp of app_emp_id" [ngValue]="resp.item_id">{{resp.item_name}}</option>
          </select>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label> {{ generalLang.performedActivities }}</label>
        </div>
          <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="performed_activites"
            [ngClass]="formErrorClass(createForm.controls.performed_activites, createFormSubmitted)"></textarea>
        </div>
      </div>

      <!-- <div class="form-group col-sm-12">
        <div class="form-group col-sm-4">
          <label> {{  generalLang.workActivity }}</label>
          <div class="form-group col-sm-8">
            <input type="text" class="form-control" formControlName="date"
              [ngClass]="formErrorClass(createForm.controls.date, createFormSubmitted)">
          </div>
          
      </div>
      </div> -->

      <div class="form-group">
        <label class="col-sm-3 control-label" for="form-field-1">
          {{  generalLang.workActivity }}
         </label>
        <div class="col-sm-3">
                <input class="form-control" aria-label="12hr format" formControlName="starting_hour"  [ngxTimepicker]="default" readonly>
                <ngx-material-timepicker #default></ngx-material-timepicker>
         </div>

         <div class="col-sm-3">
              <!-- <input class="form-control" name="end_hour" type="text" id="timepicker1" readonly="" data-time="15:20:00.000" value="3:20 PM"> -->

              <!-- <input type="text" class="form-control" formControlName="end_hour"
              [ngClass]="formErrorClass(createForm.controls.end_hour, createFormSubmitted)">
              <div class="text-center"><small>End Hour</small></div> -->

              <input class="form-control" aria-label="12hr format" formControlName="end_hour" [ngxTimepicker]="default1" readonly>
              <ngx-material-timepicker #default1></ngx-material-timepicker>

        </div>

         <div class="col-sm-3">
              <!-- <input class="form-control" name="total_hours" type="text" id="t_hou" placeholder="hh:mm"> -->

              <input type="text" class="form-control" formControlName="total_hours"
              [ngClass]="formErrorClass(createForm.controls.total_hours, createFormSubmitted)" placeholder="hh:mm">

             <div class="text-center"><small>Total Hours</small></div>
        </div>

      </div>


      <div class="form-group">
        <label class="col-sm-3 control-label" for="form-field-1">
         </label>
        <div class="col-sm-3">
              <input type="text" class="form-control" formControlName="km_traveled"
              [ngClass]="formErrorClass(createForm.controls.km_traveled, createFormSubmitted)">

              <div class="text-center"><small>km traveled</small></div>
        </div>
         <div class="col-sm-3">
          <input type="text" class="form-control" formControlName="board_cost"
          [ngClass]="formErrorClass(createForm.controls.board_cost, createFormSubmitted)">

          <div class="text-center"><small>Cost of board and lodging </small></div>
        </div>
         <div class="col-sm-3">
          <input type="text" class="form-control" formControlName="other_costs"
          [ngClass]="formErrorClass(createForm.controls.other_costs, createFormSubmitted)">

          <div class="text-center"><small>Others costs</small></div>
        </div>
      </div>




      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label> {{ generalLang.documentFound }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="found_document"
            [ngClass]="formErrorClass(createForm.controls.found_document, createFormSubmitted)"></textarea>
        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label> {{ generalLang.activites_schedule }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="activites_schedule"
            [ngClass]="formErrorClass(createForm.controls.activites_schedule, createFormSubmitted)"></textarea>
        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label> {{ generalLang.notes }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="notes"
            [ngClass]="formErrorClass(createForm.controls.notes, createFormSubmitted)"></textarea>
        </div>
      </div>



    </div>
  </div>

  <div class="modal-footer">
    <!-- <button type="close" class="btn btn-success">{{ generalLang?.close }}</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>

  </div>
</form>
